<div class="page-wrap height-100 black">
  <div class="session-form-hold">
    <mat-progress-bar mode="determinate" class="session-progress"></mat-progress-bar>
    <mat-card>
      <mat-card-content>
        <!-- Language Switcher -->
        <div class="session-language-select">
          <language-switcher></language-switcher>
        </div>
        <div class="text-center pt-8 pb-16">
          <img width="60px" height="71.69px" src="assets/images/logo-lg.png" alt="" class="mb-05">
          <p class="text-muted m-0">{{ 'Sign in to your account' | translate}}</p>
        </div>
        <form [formGroup]="signinForm" (ngSubmit)="signin()">
          <div class="">
            <mat-form-field class="full-width">
              <input matInput formControlName="email" placeholder="Email">
            </mat-form-field>
            <mat-error *ngIf="signinForm.controls['email'].hasError('required') && signinForm.controls['email'].touched"
                       class="form-error-msg-large">{{ 'Enter e-mail address' | translate }}</mat-error>
          </div>

          <div class="">
            <mat-form-field class="full-width">
              <input type="password" formControlName="password" matInput placeholder="{{ 'Password' | translate }}">
            </mat-form-field>
            <mat-error *ngIf="signinForm.controls['password'].hasError('required') && signinForm.controls['password'].touched"
                       class="form-error-msg-large">{{ 'Enter password' | translate }}</mat-error>
            <mat-error *ngIf="passwordErrMsg && signinForm.pristine"
                       class="form-error-msg-large">
              {{ 'Incorrect password' | translate }}
            </mat-error>
          </div>

          <div class="pb-1">
            <mat-checkbox formControlName="rememberMe" class="pb-1" [disableRipple]="true">{{ 'Remember this computer' | translate }}</mat-checkbox>
          </div>

          <button mat-raised-button class="mat-primary full-width mb-1" [disabled]="signinForm.invalid">{{ 'Sign in' | translate }}</button>
          <div class="text-center">
            <a [routerLink]="'/sessions/forgot-password'" class="mat-primary text-center full-width">{{ 'Forgot password' | translate }}</a>
            <span fxFlex></span>
            <a [routerLink]="'/sessions/signup_user'" class="mat-primary text-center full-width">{{ "Create a new account" | translate }}</a>
          </div>
        </form>
          <div class="lines-container mb-1 mt-1" *ngIf="oauth_buttons?.length > 0 || saml_buttons?.length > 0">
            <div class="line"><mat-divider [inset]="true"></mat-divider></div>
            <div style="padding-left: 10px; padding-right: 10px;"><strong class="text-muted m-0">{{ 'OR' | translate}}</strong></div>
            <div class="line"><mat-divider [inset]="true"></mat-divider></div>
          </div>
          <div fxLayout="column" *ngIf="oauth_buttons">
          <button *ngIf="oauth_buttons.includes(gSuiteTypeName)" mat-raised-button class="google-button auth-button full-width mb-05" (click)="OAuth(google)">
            <svg class="auth-icon" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
              <g>
                <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                <path fill="none" d="M0 0h48v48H0z"></path>
              </g>
            </svg>
            <span class="sign-in-text">{{ 'Sign in with' | translate }} {{ google }}</span>
          </button>
          <button *ngIf="oauth_buttons.includes(azureADTypeName)" mat-raised-button class="microsoft-button auth-button full-width mb-05" (click)="OAuth(microsoft)">
            <svg class="auth-icon" xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
                <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
                <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
                <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
                <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
            </svg>
            <span class="sign-in-text">{{ 'Sign in with' | translate }} {{ microsoft }}</span>
          </button>
          </div>
          <button *ngFor="let b of saml_buttons" mat-raised-button class="saml-button auth-button full-width mb-05" (click)="samlLogin(b.id)">
            <mat-icon style="font-size: 21px; margin-right: 4px; margin-left: -2px;">lock</mat-icon>
            <span class="sign-in-text">{{ 'Sign in with' | translate }} {{ microsoftSAML }}
              <span style="color: grey; font-weight: 600;" *ngIf="saml_buttons.length > 1"> ({{ b.name }} {{ 'directory' | translate }})</span>
            </span>
          </button>
      </mat-card-content>
    </mat-card>
  </div>
</div>

